import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import EN from "@/constants/en";

const Education = () => {
    return (
        <section id="education" className="section bg-white">
            <div className="container-custom">
                <h2 className="section-title">{EN.EDUCATION_SECTION_TITLE}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Card className="h-full">
                        <CardHeader>
                            <CardTitle>{EN.EDUCATION_CARD_TITLE}</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <h3 className="text-lg font-semibold">{EN.EDUCATION_DEGREE}</h3>
                            <p className="text-muted-foreground">{EN.EDUCATION_UNIVERSITY}</p>
                        </CardContent>
                    </Card>

                    <Card className="h-full">
                        <CardHeader>
                            <CardTitle>{EN.EDUCATION_CERT_TITLE}</CardTitle>
                        </CardHeader>
                        <CardContent>
                            <ul className="space-y-2 list-disc pl-5">
                                {EN.EDUCATION_CERT_ITEMS.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </section>
    );
};

export default Education;
